export default "__VITE_ASSET__BB2eoPjF__"